const PostContentSkeleton = () => (
  <div className="w-full animate-pulse space-y-8 py-4">
    <div className="space-y-3">
      <div className="h-4 rounded bg-black/[0.07]" />
      <div className="h-4 w-11/12 rounded bg-black/[0.07]" />
      <div className="h-4 w-4/5 rounded bg-black/[0.07]" />
    </div>
    <div className="space-y-3">
      <div className="h-4 rounded bg-black/[0.07]" />
      <div className="h-4 w-10/12 rounded bg-black/[0.07]" />
      <div className="h-4 w-9/12 rounded bg-black/[0.07]" />
      <div className="h-4 rounded bg-black/[0.07]" />
      <div className="h-4 w-7/12 rounded bg-black/[0.07]" />
    </div>
    <div className="space-y-3">
      <div className="h-4 rounded bg-black/[0.07]" />
      <div className="h-4 rounded bg-black/[0.07]" />
      <div className="h-4 w-8/12 rounded bg-black/[0.07]" />
    </div>
  </div>
);

export { PostContentSkeleton };
